import React from "react";
import classNames from "classnames";

interface FloatingButtonProps {
  children: React.ReactNode;
  className?: string;
  zClassName?: string;
  posClassName?: string;
  type: "primary" | "default";
  onClick: () => void;
  disabled?: boolean;
}
const FloatingButton = ({
  children,
  onClick,
  className,
  zClassName = "tw-z-30",
  posClassName = "tw-bottom-4",
  type = "primary",
  disabled = false,
  ...props
}: FloatingButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={classNames(
        styles.base(type, disabled),
        className,
        posClassName,
        zClassName,
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

const styles = {
  base: (type: "primary" | "default", disabled = false) =>
    classNames(
      "tw-fixed",
      "tw-rounded-full tw-px-4 tw-py-2",
      type === "primary"
        ? "tw-right-4 tw-bg-fay-500 tw-text-white active:tw-bg-fay-700"
        : "active:tw-by-fay-200 tw-left-4 tw-border-fay-200 tw-bg-fay-50 tw-text-neutral-700",
      "tw-shadow-md tw-transition-all",
      "active:tw-translate-y-1 active:tw-shadow-sm",
      disabled ? "tw-cursor-not-allowed tw-opacity-50" : "hover:tw-shadow-lg",
    ),
};

export default FloatingButton;
